module.exports = __webpack_public_path__ + "static/media/omega.801c28fe.svg";